// extracted by mini-css-extract-plugin
export default {"popover-content-container":"_gl8akh","popoverContentContainer":"_gl8akh","language":"_11kpra4"};